import React from "react";
import { MenuItem, OutlinedTextFieldProps } from "@mui/material";
import {
  UseFormRegister,
  RegisterOptions,
  FieldError,
} from "react-hook-form/dist/types";

import * as Styled from "./styles";

interface InputProps extends Omit<OutlinedTextFieldProps, "error" | "variant"> {
  error: FieldError | undefined;
  name: string;
  register: UseFormRegister<any>;
  registerOptions?: RegisterOptions<any, string>;
  selectOptions?: {
    name: string;
    value: string;
  }[];
}

const Input = ({
  label,
  error,
  name,
  register,
  registerOptions,
  selectOptions,
  ...rest
}: InputProps) => {
  const { ref, ...inputProps } = register(name, registerOptions);
  return (
    <Styled.Input
      margin="none"
      variant="outlined"
      label={label}
      error={!!error}
      helperText={error?.message}
      inputRef={ref}
      size="small"
      {...inputProps}
      {...rest}
    >
      {rest.select &&
        selectOptions &&
        !!selectOptions.length &&
        selectOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.name}
          </MenuItem>
        ))}
    </Styled.Input>
  );
};

export default Input;
